import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Header from "./Header";
import Menu from "../GerirDetalheTurma/Menu/Menu";
import VisaoGeralDisciplina from "./VisaoGeral/VisaoGeralDisciplina";
import VisaoGeralTurma from "./VisaoGeral/VisaoGeralTurma";
import Modulos from "./Modulos/Modulos";
import Diario from "./Diario/Main";
import GerirHorario from "./GerirHorario/GerirHorario";
import FrequenciaDiaria from "./Diario/Frequencia/Diaria";
import FrequenciaPorPeriodo from "./Diario/Frequencia/PorPeriodo";
import Detalhe from "./Diario/Detalhe";
import ListaRelatorios from "./Diario/ListaRelatorios";
import ListaRelatoriosApc from "./Diario/ListaRelatoriosApc";
import ListaNotasConceito from "./Diario/ListaNotasConceito";
import ListaFrequencia from "./Diario/Paginas/Frequencias/ListaFrequencia";
import ListaObservacoes from "./Diario/ListaObservacoes";
import ListaPareceres from "./Diario/ListaPareceres";
import Pareceres from "./Diario/Pareceres/Pareceres";
import TurmaPareceres from "./Diario/Pareceres/TurmaPareceres";
import ListaConteudos from "./Diario/ListaConteudos";
import ListaDisciplinas from "./ListaDisciplinas/ListaDisciplinas";
import Forum from "./Foruns/Forum";
import ForumDetalhe from "./Foruns/ForumDetalhe";
import Ficheiros from "./Ficheiros/Ficheiros";
import Participantes from "./Participantes/Participantes";
import Aproveitamento from "./Aproveitamento/Aproveitamento";
import AproveitamentoTurma from "./Aproveitamento/AproveitamentoTurma";
import AproveitamentoNotasDetalhe from "./Aproveitamento/Notas/Detalhe";
import AproveitamentoConceitos from "./Aproveitamento/Conceitos/Conceitos";
import AproveitamentoConceitosPautasDetalhe from "./Aproveitamento/Conceitos/Pautas/Detalhe";
import AproveitamentoConceitosAlunos from "./Aproveitamento/Conceitos/Alunos/Alunos";
import AproveitamentoConceitosAlunosTurma from "./Aproveitamento/Conceitos/Alunos/AlunosTurma";
import AproveitamentoConceitosAlunosDetalhe from "./Aproveitamento/Conceitos/Alunos/Detalhe";
import AproveitamentoNotasAlunos from "./Aproveitamento/Notas/Alunos/Alunos";
import AproveitamentoNotasAlunosTurma from "./Aproveitamento/Notas/Alunos/AlunosTurma";
import AproveitamentoNotasAlunosDetalhe from "./Aproveitamento/Notas/Alunos/Detalhe";
import AproveitamentoBnccPautasDetalhe from "./Aproveitamento/Bncc/Pautas/Detalhe";
import AproveitamentoBnccAlunosDetalhe from "./Aproveitamento/Bncc/Alunos/Detalhe";
import AproveitamentoRelatorios from "./Aproveitamento/Relatorios/Relatorios";
import Resultados from "./Resultados/Main";
import Ranking from "./Resultados/Ranking";
import Videoconferencias from "./Videoconferencias/Main";
import { GlobalContext } from "../app/providers/GlobalState";
import ContextProvider from "./ContextProvider";
import { GeralContext } from "./ContextProvider";
import axios from "axios";

class Layout extends Component {
    static contextType = GlobalContext;
    state = {
        //HEADER
        conteudoHeader: true,
        //MENU
        menuSemHeader: true,
        matriz: false,
        //REDIRECT
        redirect: false,
        redirectLink: ""
    };
    //CHAMADA ANTES DO RENDER
    UNSAFE_componentWillMount() {
        axios.defaults.timeout = 60 * 10 * 1000;
        this.temComandos(localStorage.getItem("codigo_curso"));
    }

    componentDidUpdate() {
        if (!this.context.is_authenticated || this.context.role === "UTILIZADOR") {
            if (!this.context.is_authenticated)
                this.setState({
                    redirect: true,
                    redirectLink: "/login"
                });
        }
    }

    UNSAFE_componentWillReceiveProps(prevProps) {
        if (prevProps.match.params.turma !== this.props.match.params.turma) {
            this.temComandos(localStorage.getItem("codigo_curso"));
        }
    }

    //VALIDA SE O UTILIZADOR LOGGEDIN TEM ACESSO AOS CONTROLOS CRUD DA PAGINA
    temComandos = cursoId => {
        axios({
            method: "get",
            url: "/api/autenticacao/tem-comandos",
            params: {
                cursoId
            }
        })
            .then(response => {
                localStorage.setItem("tem_comandos", response.data);
            })
            .catch(() => {});
    };

    render() {
        const {
            header,
            //REDIRECT
            redirect,
            redirectLink
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        return (
            <>
                <ContextProvider>
                    <Header matriz={this.state.matriz} state={this.state} />
                    <GeralContext.Consumer>{context => <Menu context={context} />}</GeralContext.Consumer>
                    <Switch>
                        <Route path="/gerir-multisseriado/:turma/visao-geral-disciplina" component={VisaoGeralDisciplina} />
                        <Route path="/gerir-multisseriado/:turma/visao-geral" component={VisaoGeralTurma} />
                        <Route path="/gerir-multisseriado/:turma/modulos" component={Modulos} />
                        <Route path="/gerir-multisseriado/:turma/disciplinas" component={ListaDisciplinas} />
                        <Route path="/gerir-multisseriado/:turma/horario-disciplina" component={Diario} />
                        <Route path="/gerir-multisseriado/:turma/horario" component={GerirHorario} />
                        <Route path="/gerir-multisseriado/:turma/horario-detalhe" component={Detalhe} />
                        <Route path="/gerir-multisseriado/:turma/diario-frequencia-diaria" component={FrequenciaDiaria} />
                        <Route path="/gerir-multisseriado/:turma/diario-frequencia-por-periodo" component={FrequenciaPorPeriodo} />
                        <Route path="/gerir-multisseriado/:turma/diario-detalhe" component={Detalhe} />
                        <Route path="/gerir-multisseriado/:turma/relatorios-notas" component={ListaRelatorios} />
                        <Route path="/gerir-multisseriado/:turma/relatorios-apc" component={ListaRelatoriosApc} />
                        <Route path="/gerir-multisseriado/:turma/diario-folha-conceito" component={ListaNotasConceito} />
                        <Route path="/gerir-multisseriado/:turma/diario-folha-frequencia" component={ListaFrequencia} />
                        <Route path="/gerir-multisseriado/:turma/diario-folha-observacoes" component={ListaObservacoes} />
                        {/*<Route path="/gerir-multisseriado/:turma/diario-folha-pareceres" component={ListaPareceres} />*/}
                        <Route
                            path="/gerir-multisseriado/:turma/diario-folha-pareceres"
                            component={localStorage.getItem("entidade_id") === "33" ? Pareceres : ListaPareceres}
                        />
                        {/*<Route path="/gerir-detalhe-turma/:turma/diario-folha-pareceres" component={DisciplinaPareceres} />*/}
                        <Route path="/gerir-multisseriado/:turma/diario-folha-pareceres-turma" component={Pareceres} />
                        <Route path="/gerir-multisseriado/:turma/diario-folha-conteudos" component={ListaConteudos} />
                        <Route path="/gerir-multisseriado/:turma/forum" component={Forum} />
                        <Route path="/gerir-multisseriado/:turma/forum-detalhe" component={ForumDetalhe} />
                        <Route path="/gerir-multisseriado/:turma/ficheiros" component={Ficheiros} />
                        <Route path="/gerir-multisseriado/:turma/resultados" component={Resultados} />
                        <Route path="/gerir-multisseriado/:turma/ranking" component={Ranking} />
                        <Route path="/gerir-multisseriado/:turma/videoconferencias" component={Videoconferencias} />
                        <Route path="/gerir-multisseriado/:turma/participantes" component={Participantes} />
                        <Route
                            path="/gerir-multisseriado/:turma/aproveitamento"
                            component={localStorage.getItem("vista") === "TURMA" ? AproveitamentoTurma : Aproveitamento}
                        />
                        <Route path="/gerir-multisseriado/:turma/aproveitamento-notas/:code" component={AproveitamentoNotasDetalhe} />
                        <Route
                            path="/gerir-multisseriado/:turma/aproveitamento-conceitos-pautas/:code"
                            component={AproveitamentoConceitosPautasDetalhe}
                        />
                        <Route
                            path="/gerir-multisseriado/:turma/aproveitamento-conceitos-lista-alunos"
                            component={
                                localStorage.getItem("vista") === "TURMA"
                                    ? AproveitamentoConceitosAlunosTurma
                                    : AproveitamentoConceitosAlunos
                            }
                        />
                        <Route
                            path="/gerir-multisseriado/:turma/aproveitamento-conceitos-alunos/:code"
                            component={AproveitamentoConceitosAlunosDetalhe}
                        />

                        <Route
                            path="/gerir-multisseriado/:turma/aproveitamento-notas-lista-alunos"
                            component={
                                localStorage.getItem("vista") === "TURMA" ? AproveitamentoNotasAlunosTurma : AproveitamentoNotasAlunos
                            }
                        />

                        <Route
                            path="/gerir-multisseriado/:turma/aproveitamento-notas-alunos/:code"
                            component={AproveitamentoNotasAlunosDetalhe}
                        />

                        <Route
                            path="/gerir-multisseriado/:turma/aproveitamento-bncc-pautas/:code"
                            component={AproveitamentoBnccPautasDetalhe}
                        />
                        <Route
                            path="/gerir-multisseriado/:turma/aproveitamento-bncc-alunos/:code"
                            component={AproveitamentoBnccAlunosDetalhe}
                        />
                        <Route path="/gerir-multisseriado/:turma/aproveitamento-conceitos" component={AproveitamentoConceitos} />
                        <Route path="/gerir-multisseriado/:turma/relatorios-aproveitamento" component={AproveitamentoRelatorios} />
                    </Switch>
                </ContextProvider>
            </>
        );
    }
}

export default Layout;
